// extracted by mini-css-extract-plugin
module.exports = {"tooltip--container":"Tooltip_tooltip--container__UARUN","tooltip--item":"Tooltip_tooltip--item__36Vyn"};